import {lazy} from '@aboutyou/lazy-imports';
import {LoadingPageSpinner} from '@aboutyou/ui-components';
import React from 'react';

export const ContactForm = lazy(
  () =>
    import('./ContactForm.eager').then(mod => ({
      default: mod.ContactForm,
    })),
  {
    fallback: <LoadingPageSpinner />,
    aboveTheFold: true,
  },
);
